import { Table } from "antd";
import PropTypes from "prop-types";

const EmailTemplateVariablesTable = ({ columns, rows }) => {
  const dataSource = (rows || []).map((row, index) => ({
    key: row.token || String(index),
    token: row.token,
    description: row.description,
  }));

  return (
    <div className="email-template-variables-table">
      <Table
        size="small"
        pagination={false}
        columns={[
          {
            title: columns?.VARIABLE,
            dataIndex: "token",
            key: "token",
            width: "32%",
            render: (text) => (
              <code className="email-template-variables-table__code">
                {text}
              </code>
            ),
          },
          {
            title: columns?.DESCRIPTION,
            dataIndex: "description",
            key: "description",
          },
        ]}
        dataSource={dataSource}
      />
    </div>
  );
};

EmailTemplateVariablesTable.propTypes = {
  columns: PropTypes.shape({
    VARIABLE: PropTypes.string,
    DESCRIPTION: PropTypes.string,
  }),
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      token: PropTypes.string,
      description: PropTypes.string,
    }),
  ),
};

EmailTemplateVariablesTable.defaultProps = {
  columns: {},
  rows: [],
};

export default EmailTemplateVariablesTable;
